import { render, staticRenderFns } from "./messageItem.vue?vue&type=template&id=7ed5bfaa&scoped=true&"
import script from "./messageItem.vue?vue&type=script&lang=js&"
export * from "./messageItem.vue?vue&type=script&lang=js&"
import style0 from "./messageItem.vue?vue&type=style&index=0&id=7ed5bfaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed5bfaa",
  null
  
)

export default component.exports